/**
 * ChurchFlow logo — Half Dome (Yosemite) rising over flowing water,
 * a nod to Fresno's gateway role to the Sierra Nevada and the app's
 * theme of stewardship "flowing" through the ministry.
 */
export default function ChurchFlowLogo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="ChurchFlow"
      role="img"
    >
      <defs>
        <linearGradient id="cf-bg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1e4ed8" />
          <stop offset="55%" stopColor="#1d4ed8" />
          <stop offset="100%" stopColor="#0b3aa8" />
        </linearGradient>
        <linearGradient id="cf-dome" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.98" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.78" />
        </linearGradient>
        <linearGradient id="cf-back-peak" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.30" />
        </linearGradient>
      </defs>

      {/* Rounded-square badge background */}
      <rect x="0" y="0" width="48" height="48" rx="12" fill="url(#cf-bg)" />

      {/* Faint back peak (Sierra ridge) */}
      <path
        d="M2 30 L14 17 L24 25 L34 14 L46 30 Z"
        fill="url(#cf-back-peak)"
      />

      {/* Half Dome silhouette — vertical cliff face on the left, sloping back to the right */}
      <path
        d="M11 32 L11 22 C 11 17.5, 14.5 14, 19 13.6 C 23 13.3, 27 15.5, 29.5 19 L34 28 L34 32 Z"
        fill="url(#cf-dome)"
      />

      {/* Sun / moon orb behind the dome */}
      <circle cx="36" cy="14" r="2.6" fill="#FDE68A" opacity="0.95" />

      {/* Flowing water — two stacked wave lines beneath the peaks */}
      <path
        d="M3 37 C 9 34, 15 40, 21 37 S 33 34, 39 37 S 45 40, 47 39"
        stroke="#ffffff"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
        opacity="0.95"
      />
      <path
        d="M3 42 C 9 39, 15 45, 21 42 S 33 39, 39 42 S 45 45, 47 44"
        stroke="#ffffff"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.55"
      />
    </svg>
  );
}
